module.exports = __webpack_public_path__ + "static/47-18f53a63dc906b9725b5239e3f48825c.jpg";